import {
    CalculationEngineMonthlyValueOverrides,
    Currency,
    DemeterCalculationEngineLineShortModel,
    DemeterCommodity,
    DemeterFilterTimeSpan,
    DemeterMarket,
    DemeterSymbolModel,
    FuturesDirection,
    InsuranceState,
    MonthlyBudgetModel,
    UnitOfMeasure,
} from '../../../Generated/Raven-Demeter';

export interface MonthlyRiskCompositeModel extends MonthlyBudgetModel {
    dataMonth: number;
    dataYear: number;
    budgetVersesMarketDifference?: number;
    budgetVersesMarketTotal?: number;
    budgetVersesMarketVolume?: number;
    price?: number;
    eurToUsdCurrencyConversionRate?: number;
    currencyConversionRate?: number;
    priceConverted?: number;
    basis: number;
    priceConvertedWithBasis?: number;
    physicalPositionNetLongPosition?: number;
    physicalPositionNetLongPrice?: number;
    physicalPositionNetSalesPosition?: number;
    physicalPositionNetSalesPrice?: number;
    physicalPositionSecuredPosition?: number;
    physicalPositionSecuredPrice?: number;
    physicalPositionSecuredTotal?: number;
    physicalUserOverride?: boolean;
    combinedPosition?: number;
    combinedPrice?: number;
    netUnhedgedPosition?: number;
    netUnhedgedPrice?: number;
    markToMarketAdjusted?: number;
    markToBudgetOfNetCoveredDifference?: number;
    markToBudgetOfNetCoveredTotal?: number;
    markToMarketPriceDifference?: number;
    markToMarketOfNetCoveredDifference?: number;
    markToMarketOfNetCoveredTotal?: number;
    markToMarketTotal?: number;
    riskDays?: number;
    riskMonthly?: number;
    riskCumulative?: number;
    riskMargin?: number;
    riskRange?: number;
    isUpdatedValue?: boolean;
}

export interface GetFarmerMarginCalculatorCompositeRowsModel {
    isUpdatedValue?: boolean;
}

export interface RiskRequest {
    basisString: string;
    basis: number;
    currency?: Currency;
    direction: FuturesDirection;
    probability: number;
    risks?: MonthlyRiskCompositeModel[];
    unitOfMeasure?: UnitOfMeasure;
    volatilityTimeSpan: DemeterFilterTimeSpan;
    version: number;
}

export type DemeterCalculationEngineLineShortModelWithChildren = DemeterCalculationEngineLineShortModel & {
    children?: DemeterCalculationEngineLineShortModelWithChildren[];
    isReadOnly?: boolean;
    combinedWith?: DemeterCalculationEngineLineShortModelWithChildren[];
    stickyColumnElement?: JSX.Element;
    rowElement?: JSX.Element;
    key?: string;
};

export type HideGroup = {
    [key: string]: boolean;
};

export type UpsertCalculationEngine = {
    demeterCalculationEngineGuid: string;
    demeterCalculationEngineInputsGuid?: string;
    name: string;
    groupName: string;
    valueOverrides: {};
    dataOverrides: {};
    textOverrides: { [key: string]: string };
    monthlyValueOverrides: Array<CalculationEngineMonthlyValueOverrides>;
};

export interface MarginCompositeModel {
    asOfDate: string;
    futuresBlendPrice: DemeterCalculationEngineLineShortModelWithChildren;
    productionLines: DemeterCalculationEngineLineShortModel[];
    production: DemeterCalculationEngineLineShortModelWithChildren;
    outputHedgedVolume: DemeterCalculationEngineLineShortModelWithChildren;
    outputHedgedPrice: DemeterCalculationEngineLineShortModelWithChildren;
    costTotalPrice: DemeterCalculationEngineLineShortModelWithChildren;
    hedgedMargin: DemeterCalculationEngineLineShortModelWithChildren;
    outputHedgedPercent: DemeterCalculationEngineLineShortModelWithChildren;
    unhedgedMargin: DemeterCalculationEngineLineShortModelWithChildren;
    netMargin: DemeterCalculationEngineLineShortModelWithChildren;
    isUpdatedValue?: boolean;
}

export type MarginQuarterValue = { quarter: number; year: number };

export type MarginQuarterOptions = { label: string; value: MarginQuarterValue };

export type MarginRequest = {
    market: DemeterMarket;
    product: DemeterSymbolModel;
    startingQuarter: MarginQuarterValue;
    endingQuarter: MarginQuarterValue;
};

export type MarginHeatMapTableDates = { coverageTableStartDate: { label: string; value: Date }; coverageTableEndDate: { label: string; value: Date } };

export type LiquidityRiskCalculationInputs = {
    insuranceYear: number;
    coverageEffectiveDate: string;
    insuredSharedPercentage: number;
    endorsementLength: number[];
    endWeight: number;
    insuranceState: InsuranceState;
    commodity: DemeterCommodity;
    type: DemeterCommodity[];
    animalHeadCount: number;
    costPerPoundOfGrain?: number;
    shortWeight?: number;
    purchaseCostPerAnimal?: number;
};

export const endorsementLengthOptions = [
    {
        label: '13',
        value: 13,
    },
    {
        label: '17',
        value: 17,
    },
    {
        label: '21',
        value: 21,
    },
    {
        label: '26',
        value: 26,
    },
    {
        label: '30',
        value: 30,
    },
    {
        label: '34',
        value: 34,
    },
    {
        label: '39',
        value: 39,
    },
    {
        label: '43',
        value: 43,
    },
    {
        label: '47',
        value: 47,
    },
];

// TODO: more fields will be added once endpoint is completed.
export type ContactAgentRequest = {
    subject: string;
    message: string;
};

export type TabEventKeyType = 'ArrowLeft' | 'ArrowRight' | 'ArrowUp' | 'ArrowDown' | 'Enter';
